<template>
  <div class="reading-day-card"
       :class="`type-${typeName}`">
    <ym-img class="reading-day-card-title"
            :class="`type-${typeName}`"
            :src="require(`@/pages/2021/ReadingDay/assets/img/title_${typeName}.png`)"
    />
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      typeName: {
        type: String,
        required: true,
      },
    },
    data() {
      return {};
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .reading-day-card {
    position: relative;
    margin-bottom: 160px;
    &-title {
      position: absolute;
      left: 50%;
      top: -38px;
      width: 515px;
      height: 126px;
      margin-left: -258px;
      z-index: 2;
      &.type-million {
        height: 96px;
      }
      &.type-rule {
        height: 76px;
      }
    }
    &.type-live,
    &.type-group,
    &.type-audio,
    &.type-rule {
      width: 100%;
      background: @color-white;
      border-radius: 35px;
    }
    &.type-million {
      width: 100%;
      height: 1042px;
      background: url('~@/pages/2021/ReadingDay/assets/img/million_bg.png');
      background-size: 100%;
    }
    &.type-project {
      width: 100%;
      background: @color-white;
    }
  }
</style>
